import axios from "axios";
import { getBackendUrl as resolveBackendUrl } from "./runtimeConfig";

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tf_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (error) => {
        if (error?.response?.status === 401) {
            // token invalid; clear and redirect
            if (window.location.pathname !== "/login") {
                localStorage.removeItem("tf_token");
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    },
);

export function formatApiErrorDetail(detail) {
    if (detail && (detail.isAxiosError || detail.response)) {
        const d = detail.response?.data?.detail;
        return d != null ? formatApiErrorDetail(d) : (detail.message || "Something went wrong. Please try again.");
    }
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    if (detail && typeof detail.message === "string") return detail.message;
    if (detail && typeof detail.code === "string") return [detail.code.replace(/_/g, " "), detail.running_job_id].filter(Boolean).join(" · ");
    return String(detail);
}
